module.exports = __webpack_public_path__ + "img/todos-por-el-peru.13270807.png";